import React, { useEffect, useState } from "react";
import { Typography } from "antd";
import moment from "moment";
import { useSelector } from "react-redux";
import { useUserBranches } from "../../../hooks/accessControl";
import { getLocalPhoneNumber } from "../../../components/util/helpers";
const { Text } = Typography;

const CompanyDetails = (props) => {
  const userBranches = useUserBranches();
  const [branchName, setBranchName] = useState("");
  const [branchAddress, setBranchAddress] = useState("");
  const [branchPhone, setBranchPhone] = useState("");

  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );
  useEffect(() => {
    const branch = userBranches.filter((i) => i.id === activePatient.branch)[0];
    if (branch) {
      setBranchName(branch.name);
      const branchAdd = branch.address;
      const street = branchAdd["street"]
        ? branchAdd["street"] + " " + branchAdd["house_number"]
        : "";
      const address =
        branchAdd["city"] !== undefined
          ? branchAdd["city"] + ", " + street
          : street;
      setBranchAddress(address);
      setBranchPhone(branch.phone_number);
    }
  }, [userBranches, activePatient.branch]);
  const avatar_url = useSelector(
    (state) => state.organization.details.avatar_url
  );
  const organizationName = useSelector(
    (state) => state.organization.details.name
  );
  return (
    <div className="print_header">
      <div className="spacerContainer">
        <div className="item_container">
          <Text>{`${organizationName} - ${branchName}`}</Text>
          <Text>{`${branchAddress} - ${getLocalPhoneNumber(
            branchPhone
          )}`}</Text>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
          }}
        >
          {avatar_url ? (
            <img
              src={avatar_url}
              alt={"logo"}
              style={{ height: "40px", objectFit: "contain" }}
            />
          ) : null}
          <Text style={{ width: "200px", textAlign: "left" }}>
            {moment().format("DD/MM/YYYY")}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default CompanyDetails;
